type RedirectQueryValue = string | null | undefined

export function getSafeRedirectPath(
  redirectUrl: RedirectQueryValue | RedirectQueryValue[],
  origin: string
): string {
  const raw = Array.isArray(redirectUrl) ? redirectUrl[0] : redirectUrl

  if (!raw || typeof raw !== 'string') {
    return '/'
  }

  // Some browsers normalize backslashes to slashes, which can turn
  // "\evil.example" into a network-path / open redirect.
  if (raw.includes('\\')) {
    return '/'
  }

  try {
    const url = new URL(raw, origin)

    if (url.origin !== origin) {
      return '/'
    }

    return url.pathname + url.search + url.hash || '/'
  } catch {
    return '/'
  }
}
